import { __assign, __read, __spreadArray } from "tslib";
import { capitalize, get } from 'lodash-es';
import * as handoffItems from '../../constants/handoffItems';
import { getColorFills, getColorStops } from './colors';
export function hasAssets(element) {
    return getAssets(element).length > 0;
}
export function getAssets(element) {
    var assets = get(element, 'itemProps.assets', []) || [];
    // There seems to be a bug in the Sketch plugin that results in some assets having an empty url so
    // we filter them out here. See https://marvelapp.atlassian.net/browse/SP-688
    return assets.filter(function (asset) { return asset.url; });
}
export function getElementColors(element) {
    var colors = [];
    [getElementBorders, getFills].forEach(function (getPropWithColours) {
        var props = getPropWithColours(element);
        props.forEach(function (prop) {
            if (prop.color) {
                colors.push(prop.color);
            }
            else if (prop.colors) {
                colors = colors.concat(prop.colors);
            }
        });
    });
    [getElementShadows, getElementInnerShadows].forEach(function (getShadows) {
        var shadows = getShadows(element);
        shadows.forEach(function (shadow) { return colors.push(shadow.color.rgbaValues); });
    });
    if (element.className === handoffItems.TEXT) {
        colors.push(getTextColor(element));
    }
    return colors;
}
export function getTextColor(element) {
    // TODO remove the 'get' when test fixtures are upconverted to v2
    return get(element, 'style.color.rgbaValues', []);
}
export function getContent(element) {
    return element.blocks.map(function (b) { return b.text; }).join('\n');
}
export function getTextSnippet(element) {
    return element.blocks[0].text.substr(0, 30);
}
export function getElementThumbURL(element) {
    // TODO this could be HUGE -- should we generate thumbs for the Header?
    return element.source;
}
export function getElementBlendMode(element) {
    return element.itemProps.blendMode;
}
export function getElementBlur(element) {
    return element.itemProps.blur;
}
export function getElementBorders(element) {
    var borders = get(element, 'strokes', []);
    return borders.map(function (border) {
        if (border.color.className === 'Color') {
            return {
                type: 'color',
                color: border.color.rgbaValues,
                position: capitalize(border.strokePosition),
                width: border.width,
            };
        }
        return {
            type: 'gradient',
            gradientType: border.color.type,
            colors: getColorStops(border.color.stops),
            position: capitalize(border.strokePosition),
            width: border.width,
        };
    });
}
export function getElementLayout(element) {
    return element.layout;
}
export function getElementRadius(element) {
    return element.type !== 'ellipse' && element.radius;
}
export function getElementShadows(element) {
    var shadows = [];
    var parent = element;
    while (parent) {
        shadows.push.apply(shadows, __spreadArray([], __read(get(parent, 'shadows', [])), false));
        parent = parent.positionParent;
    }
    return shadows;
}
export function getElementInnerShadows(element) {
    return element.innerShadows || [];
}
export function getFills(element) {
    var fills = get(element, 'fillStyle.fills', []);
    return getColorFills(fills);
}
export function getLayerName(element) {
    var layerName = element.itemProps.name;
    if (!layerName)
        return capitalize(element.className);
    return layerName;
}
// Determines whether an element bounding box contains another element bounding box
export function elementContains(container, contained) {
    var bbox1 = getElementLayout(container);
    var bbox2 = getElementLayout(contained);
    return (bbox1.x >= bbox2.x &&
        bbox1.y >= bbox2.y &&
        bbox1.bottom <= bbox2.bottom &&
        bbox1.right <= bbox2.right);
}
export function getSymbol(element) {
    return getSketchPluginStyle(element, 'symbolName');
}
export function getShapeStyle(element) {
    return getSketchPluginStyle(element, 'styleName');
}
export function getTextStyle(element) {
    return __assign(__assign({}, element.style), { textStyle: getSketchPluginStyle(element, 'styleName') });
}
function getSketchPluginStyle(element, styleProperty) {
    var _a, _b, _c, _d;
    var style = (_d = (_c = (_b = (_a = element === null || element === void 0 ? void 0 : element.itemProps) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MARVEL_SKETCH_PLUGIN) === null || _c === void 0 ? void 0 : _c.style) === null || _d === void 0 ? void 0 : _d[styleProperty];
    if (!style)
        return null;
    return spaceOutSlashes(style);
}
export function spaceOutSlashes(value) {
    return value.split('/').join(' / ');
}
